class Api {
    constructor() {
        this.root = null
        this.getDirectory()
    }

    getDirectory = async() => {
        const res = await fetch(process.env.REACT_APP_AUTH + '/api/auth/')
        this.root = await res.json()
    }

    loginHref = () => {
        return `${process.env.REACT_APP_ROOT}/login`
    }

    href = name => {
        for(let link of this.root.meta.links) {
            if(link.rel === name) {
                return link.href;
            }
        }
    }

    post = (href, body) => {
        return fetch(
            href, {
                method: 'POST',
                body: JSON.stringify(body),
                headers: {'Content-Type': 'application/json'}}
        )
    }
}

export const API = new Api()
export default API


// WEBPACK FOOTER //
// ./src/api.js